<div class="spinner" *ngIf="isSpinnerLoad">
    <i class="fa fa-3x fa-spin fa-spinner"></i>
</div>
